import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tracking-page-banner',
  templateUrl: './tracking-page-banner.component.html',
  styleUrls: ['./tracking-page-banner.component.scss'],
})
export class TrackingPageBannerComponent implements OnInit {
  imageUrl: string = '';
  uploadImage: string;
  productImage: string = "/assets/images/default-product.png";
  errorMessage: string;
  constructor() { }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.imageUrl = event.target.files[0];
    this.errorMessage = "";
    // this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.errorMessage = "";
    this.uploadImage = '';
    this.imageUrl = '';
  }
  ngOnInit() { }

}
